import * as $ from 'jquery';
import 'bootstrap';

export class signpostSection {
    initializaSignPost() {
        let maxCount: any = $('[data-tiles-total-count]').length > 0 ? parseInt($('[data-tiles-total-count]').attr('data-tiles-total-count')) : 8;
        let rowCount: any = $('[data-tiles-row-count]').length > 0 ? parseInt($('[data-tiles-row-count]').attr('data-tiles-row-count')) : 4;
        let rowCountMobile: any = $('[data-tiles-row-count-mobile]').length > 0 ? parseInt($('[data-tiles-row-count-mobile]').attr('data-tiles-row-count-mobile')) : 2;
        let signpostSection: any = $('#mh-explorer-section #signpost-section .content--image .col-xs-6');
        let signpostSectionMobile: any = $('#mh-explorer-section #signpost-section .content--image .col-sm-4');
        if (maxCount % rowCount === 0) {
            $(signpostSection).each(function (itemCount: any) {
                $(this).css({ 'max-width': 100 / rowCount + '%', 'flex-basis': 100 / rowCount + '%' });
            });
            if (window.innerWidth < 1024) {
                $(signpostSectionMobile).each(function (itemCount: any) {
                    $(this).css({ 'max-width': 100 / rowCountMobile + '%', 'flex-basis': 100 / rowCountMobile + '%'});
                });
            }
        }
        else {
            $(signpostSection).each(function (itemCount: any) {
                if (itemCount < Math.floor(maxCount / rowCount) * rowCount) {
                    $(this).css({ 'max-width': 100 / rowCount + '%', 'flex-basis': 100 / rowCount + '%' });
                }
                else {
                    $(this).css({ 'max-width': 100 / (maxCount % rowCount) + '%', 'flex-basis': 100 / (maxCount % rowCount) + '%' });
                }
            });
            if (window.innerWidth < 1024) {
                $(signpostSectionMobile).each(function (itemCount: any) {
                    if (itemCount < Math.floor(maxCount / rowCountMobile) * rowCountMobile) {
                        $(this).css({ 'max-width': 100 / rowCountMobile + '%', 'flex-basis': 100 / rowCountMobile + '%' });
                    }
                    else {
                        $(this).css({ 'max-width': 100 / (maxCount % rowCountMobile) + '%', 'flex-basis': 100 / (maxCount % rowCountMobile) + '%' });
                    }
                });
            }
        }
    }
   tileAnimation(){
    $(document).on('scroll',function(){
      let scrollTop = $(this).scrollTop();
      let signpostSection: any = $('#mh-explorer-section #signpost-section .content--image .col-xs-6 .image-icon');
      let signpostSectionPosition:any=$('#signpost-section').position().top;
      let signpostSectionHeight:any = $('#mh-explorer-section #signpost-section .content--image .col-xs-6').innerHeight();
     
       if(scrollTop>=signpostSectionPosition &&scrollTop <= signpostSectionPosition+signpostSectionHeight )
        
       {
         signpostSection.removeClass('animationScroll');
      }
      else{
        signpostSection.addClass('animationScroll');  
      }
    });
   } 
}

let scope: Element = document.querySelector('#signpost-section');
if (scope) {
    try {
        let signpost = new signpostSection();
        signpost.initializaSignPost();
        signpost.tileAnimation();
    } catch (e) { console.error(e); }
}